var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCalendarBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.93833 2.85215C7.20399 3.10707 7.2127 3.52909 6.95777 3.79475L3.54207 7.35433H13.332C13.7002 7.35433 13.9987 7.65281 13.9987 8.021C13.9987 8.38919 13.7002 8.68766 13.332 8.68766H3.58267L6.95777 12.2049C7.2127 12.4706 7.20399 12.8926 6.93833 13.1475C6.67267 13.4025 6.25065 13.3938 5.99572 13.1281L1.51767 8.46142C1.27015 8.20347 1.27015 7.7962 1.51767 7.53826L5.99572 2.87159C6.25065 2.60593 6.67267 2.59722 6.93833 2.85215Z",
    fill: "#141F2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCalendarBackArrow);
export default __webpack_public_path__ + "static/media/Custom-calendar-Back-Arrow.61c2a52a411031ed26af83e5f6b6ba8e.svg";
export { ForwardRef as ReactComponent };